import React from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { CircularProgress, Tooltip } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";
import { ActionsCell } from "components/organisms/GenericTable/GenericTable.styled";

const NotificationCellMenu = ({
    notification,
    onMarkAsRead,
    onRequestDelete,
    isDeleting = false,
    isMarking = false,
    disabled = false,
}) => {
    const isRead = !!notification.read_at;
    const isBusy = isDeleting || isMarking || disabled;

    return (
        <ActionsCell
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            {!isRead ? (
                <Tooltip title="Mark as read">
                    <span>
                        <StandartButton
                            iconButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            disabled={isBusy}
                            onClick={() => onMarkAsRead?.(notification.id)}
                        >
                            {isMarking ? (
                                <CircularProgress size={16} color="inherit" />
                            ) : (
                                <DoneAllIcon fontSize="small" />
                            )}
                        </StandartButton>
                    </span>
                </Tooltip>
            ) : null}
            <Tooltip title="Delete notification">
                <span>
                    <StandartButton
                        iconButton
                        variant={ButtonVariant.DANGER_OUTLINED}
                        disabled={isBusy}
                        onClick={() => onRequestDelete?.(notification.id)}
                    >
                        {isDeleting ? (
                            <CircularProgress size={16} color="inherit" />
                        ) : (
                            <DeleteOutlineIcon fontSize="small" />
                        )}
                    </StandartButton>
                </span>
            </Tooltip>
        </ActionsCell>
    );
};

export default NotificationCellMenu;
